export default __webpack_public_path__ + "db9a3912e28fef517bd91ea13a8ff40a.png";